import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { CheckCircle, CreditCard, Truck, Trophy, MessageCircle } from 'lucide-react';

const TrustBadges = () => {
  const { t } = useLanguage();

  const badges = [
    {
      icon: CheckCircle,
      title: t('qualityGuarantee'),
      description: t('qualityGuaranteeDesc'),
    },
    {
      icon: CreditCard,
      title: t('securePayment'),
      description: t('securePaymentDesc'),
    },
    {
      icon: Truck,
      title: t('fastDelivery'),
      description: t('fastDeliveryDesc'),
    },
    {
      icon: Trophy,
      title: t('bestPrices'),
      description: t('bestPricesDesc'),
    },
    {
      icon: MessageCircle,
      title: t('support24'),
      description: t('support24Desc'),
    },
  ];

  return (
    <section className="py-8 md:py-12 bg-card border-y border-border">
      <div className="mx-auto max-w-7xl px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {badges.map((badge, index) => {
            const IconComponent = badge.icon;
            return (
              <div key={index} className="text-center">
                <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-3">
                  <IconComponent className="w-6 h-6 text-primary" />
                </div>
                <h4 className="font-semibold text-foreground mb-1">{badge.title}</h4>
                <p className="text-sm text-muted-foreground">{badge.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
